module.exports = __webpack_public_path__ + "static/media/family-biking.9f3fa41f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/carousel/images/family-biking.jpg
// module id = 551
// module chunks = 0